var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-box"},[_c('v-head',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"content"},[_c('person')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }